import React from 'react';
import ReactDOM from 'react-dom';
import { I18nProvider } from '@lingui/react';
import {
    defaultTheme,
    MaestroThemeProvider,
    GlobalStyle,
} from '@landr/maestro';
import { BrowserRouter } from 'react-router-dom';
import { i18n } from './utils/setupTranslations';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { setupLandrDevTools } from './utils/setupDevtools';

ReactDOM.render(
    <I18nProvider language={i18n.language} i18n={i18n}>
        <MaestroThemeProvider mode="dark" theme={defaultTheme}>
            <BrowserRouter>
                <GlobalStyle />
                <App />
            </BrowserRouter>
        </MaestroThemeProvider>
    </I18nProvider>,
    document.getElementById('root'),
);

setupLandrDevTools();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
